let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("38sfA"), load("h4OCL"), load("awkVi"), load("9GZ76")]).then(() => parcelRequire('dbbA6'));